const NotMatch = () => (
  <div
    style={{
      maxHeight: '25rem',
      height: '95vh',
      display: 'grid',
      placeItems: 'center',
    }}
  >
    <p
      style={{
        fontSize: '3rem',
      }}
    >
      Not found!
    </p>
  </div>
);

export default NotMatch;
